/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Checkbox,
  Divider,
  Grid,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import SearchIcon from "@material-ui/icons/Search";
import { Skeleton } from "@material-ui/lab";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import { IsMobile } from "utils/is-mobile";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    justifyContent: "space-evenly",
  },
  cardHeader: {
    fontSize: "0.95rem",
    fontFamily: "Open Sans, sans-serif",
  },
  list: {
    height: 350,
    minHeight: 200,
    maxHeight: 350,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  listItem: {
    display: "flex",
    "& > .MuiListItemText-root > span": {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      wordBreak: "keep-all",
      overflow: "hidden",
    },
  },
}));

const LoadingItem = () => (
  <ListItem style={{ padding: ".5rem" }}>
    <Skeleton />
  </ListItem>
);

const ItemsFilter = ({ label, loading, filteringItems, verifyItems }) => {
  const isMobile = IsMobile();

  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (e) => {
    e.preventDefault();

    setFilterValue(e.target.value);
  };

  const handleVerify = useCallback(() => {
    verifyItems(filterValue);
  }, [filterValue, verifyItems]);

  const onKeyPress = useCallback(
    (e) => {
      if (e.code === "Enter") {
        handleVerify();
      }
    },
    [handleVerify]
  );

  return (
    <Box display="flex" alignItems="center" width={isMobile ? "90%" : "40%"}>
      <TextField
        margin="dense"
        label={`Filtrar ${label}`}
        type="text"
        fullWidth
        variant="outlined"
        disabled={loading || filteringItems}
        value={filterValue}
        style={{ marginBottom: 10 }}
        onChange={handleFilterChange}
        inputProps={{
          onKeyPress,
        }}
      />
      <IconButtonLoader
        title="Filtrar opções"
        onClick={handleVerify}
        extraStyle={{ marginLeft: 10 }}
        icon={<SearchIcon color="primary" style={{ width: 18, height: 18 }} />}
        size="small"
        disabled={loading || filteringItems}
      />
    </Box>
  );
};

const ItemsList = ({
  label,
  initialItems,
  loading,
  childLinked,
  setChildLinked,
  parentLinked,
  setParentLinked,
}) => {
  let countMenusLeft = 0;

  const classes = useStyles();
  const isMobile = IsMobile();

  const [items, setItems] = useState(initialItems || null);
  const [countLeft, setCountLeft] = useState(0);
  const [countRight, setCountRight] = useState(0);
  const [filteringItems, setFilteringItems] = useState(false);

  const [expandedItems, setExpandedItems] = useState({});
  const [showListSubOptionsFilter, setShowListSubOptionsFilter] =
    useState(false);
  const [listSubSystemFilter, setListSubSystemFilter] = useState([]);

  const searchInChildren = useCallback(
    (children, valueToCheck, listChild, listSystemChild, parentDescricao) => {
      if (!children || children.length === 0) return false;

      let found = false;
      children.forEach((child) => {
        if (child?.Descricao?.toLowerCase().includes(valueToCheck)) {
          listChild.push(child);
          if (
            parentDescricao &&
            listSystemChild.indexOf(parentDescricao) === -1
          ) {
            listSystemChild.push(parentDescricao);
          }
          found = true;
        }

        if (child?.ListMenusFilhos && child?.ListMenusFilhos.length > 0) {
          const childFound = searchInChildren(
            child.ListMenusFilhos,
            valueToCheck,
            listChild,
            listSystemChild,
            child?.Descricao
          );
          if (childFound && listSystemChild.indexOf(child?.Descricao) === -1) {
            listSystemChild.push(child?.Descricao);
          }
          found = found || childFound;
        }
      });

      return found;
    },
    []
  );

  const verifyItems = useCallback(
    (filterValue) => {
      setFilteringItems(true);
      setExpandedItems({});
      setShowListSubOptionsFilter(false);
      setListSubSystemFilter([]);
      return new Promise((resolve) => {
        const valueToCheck = filterValue.toLowerCase();

        const listParents = [];
        const listChild = [];
        const listSystemChild = [];

        if (valueToCheck === "") {
          setItems(initialItems);
        } else {
          const newList = initialItems.filter((item) => {
            let hasMatch = false;

            item?.ListMenus?.forEach((disponiveis) => {
              if (
                disponiveis?.Descricao?.toLowerCase().includes(valueToCheck)
              ) {
                listParents.push(disponiveis);
                if (listSystemChild.indexOf(item?.Sistema) === -1) {
                  listSystemChild.push(item?.Sistema);
                }
                if (listSystemChild.indexOf(disponiveis?.Descricao) === -1) {
                  listSystemChild.push(disponiveis?.Descricao);
                }
                hasMatch = true;
              }

              if (
                disponiveis?.ListMenusFilhos &&
                disponiveis?.ListMenusFilhos.length > 0
              ) {
                const childFound = searchInChildren(
                  disponiveis.ListMenusFilhos,
                  valueToCheck,
                  listChild,
                  listSystemChild,
                  disponiveis?.Descricao
                );
                if (childFound) {
                  if (listSystemChild.indexOf(disponiveis?.Descricao) === -1) {
                    listSystemChild.push(disponiveis?.Descricao);
                  }
                  hasMatch = true;
                }
              }
            });

            if (hasMatch) {
              setShowListSubOptionsFilter(true);
              setListSubSystemFilter(listSystemChild);
              return true;
            }
            return false;
          });
          setItems(newList);
        }

        resolve(setFilteringItems(false));
      });
    },
    [initialItems, searchInChildren]
  );

  const countAllChildren = useCallback((children) => {
    if (!children || children.length === 0) return 0;
    let count = children.length;
    children.forEach((child) => {
      if (child?.ListMenusFilhos && child?.ListMenusFilhos.length > 0) {
        count += countAllChildren(child.ListMenusFilhos);
      }
    });
    return count;
  }, []);

  const countingMenusDisponiveis = useCallback(
    (menuLeft) => {
      if (!menuLeft) return;
      countMenusLeft = menuLeft?.length + countMenusLeft;
      menuLeft?.forEach((item) => {
        if (item?.ListMenusFilhos && item?.ListMenusFilhos.length > 0) {
          countMenusLeft += countAllChildren(item.ListMenusFilhos);
        }
      });
      setCountLeft(countMenusLeft);
    },
    [countAllChildren]
  );

  const countingMenusVinculados = (child, parent) => {
    setCountRight(child?.length + parent?.length);
  };

  useEffect(() => {
    if (initialItems?.length !== 0) {
      setItems(initialItems);
      countMenusLeft = 0;
      countingMenusDisponiveis(initialItems);
      initialItems?.forEach((item) => {
        countingMenusDisponiveis(item?.ListMenus);
      });
      countingMenusVinculados(childLinked, parentLinked);
    }
  }, [initialItems, childLinked, parentLinked, countingMenusDisponiveis]);

  const getAllChildrenIds = useCallback((children) => {
    if (!children || children.length === 0) return [];
    const ids = [];
    children.forEach((child) => {
      ids.push(child?.IdMenu);
      if (child?.ListMenusFilhos && child?.ListMenusFilhos.length > 0) {
        ids.push(...getAllChildrenIds(child.ListMenusFilhos));
      }
    });
    return ids;
  }, []);

  function arrayCompare(first, last) {
    const result = first.filter(function (item) {
      return last.indexOf(item) > -1;
    });
    return result.length;
  }

  const handleToggleChild = useCallback(
    (child, parent, listChild, system, parentList) => {
      let newCheckedParent = [...parentLinked];
      let newCheckedChild = [...childLinked];

      const verifyChild = listChild?.map((item) => {
        return item?.IdMenu;
      });

      const verifyParent = parentList?.map((item) => {
        return item?.IdMenu;
      });

      const childItem = listChild?.find((item) => item?.IdMenu === child);
      const allChildrenIds = childItem?.ListMenusFilhos
        ? getAllChildrenIds(childItem.ListMenusFilhos)
        : [];

      const isChildChecked = childLinked?.indexOf(child) !== -1;

      if (!isChildChecked) {
        // Adiciona o filho (nível 3)
        if (newCheckedChild?.indexOf(child) === -1) {
          newCheckedChild.push(child);
        }
        if (allChildrenIds.length > 0) {
          allChildrenIds.forEach((childId) => {
            if (newCheckedChild?.indexOf(childId) === -1) {
              newCheckedChild.push(childId);
            }
          });
        }
        // Marca o pai (nível 2) se não estiver marcado
        if (parent) {
          const parentIndex = newCheckedParent?.findIndex(
            (p) => String(p) === String(parent)
          );
          if (parentIndex === -1) {
            newCheckedParent.push(parent);
          }
        }
        // Marca o sistema (nível 1) se não estiver marcado
        if (system) {
          const systemIndex = newCheckedParent?.findIndex(
            (s) => String(s) === String(system)
          );
          if (systemIndex === -1) {
            newCheckedParent.push(system);
          }
        }
      } else {
        newCheckedChild = newCheckedChild?.filter(function (element) {
          return element !== child && !allChildrenIds.includes(element);
        });

        // Verifica se todos os filhos do pai estão desmarcados
        if (arrayCompare(newCheckedChild, verifyChild) === 0) {
          newCheckedParent = newCheckedParent?.filter(function (element) {
            return String(element) !== String(parent);
          });
        }

        // Verifica se ainda há pais marcados no sistema
        const isInArray = verifyParent.some((el) =>
          newCheckedParent.some((p) => String(p) === String(el))
        );
        if (!isInArray) {
          const currentIndexSystem = newCheckedParent?.findIndex(
            (s) => String(s) === String(system)
          );
          if (currentIndexSystem !== -1) {
            newCheckedParent.splice(currentIndexSystem, 1);
          }
        }
      }

      setParentLinked(newCheckedParent);
      setChildLinked(newCheckedChild);
    },
    [
      childLinked,
      setChildLinked,
      parentLinked,
      setParentLinked,
      getAllChildrenIds,
    ]
  );

  const handleToggleParent = useCallback(
    (parentId, child, system, parentList) => {
      const currentIndexParent = parentLinked?.findIndex(
        (p) => String(p) === String(parentId)
      );
      const newCheckedParent = [...parentLinked];
      let newCheckedChild = [...childLinked];

      const verifyChild = child?.map((item) => {
        return item?.IdMenu;
      });

      const verifyParent = parentList?.map((item) => {
        return item?.IdMenu;
      });

      const allChildrenIds = child ? getAllChildrenIds(child) : [];

      if (currentIndexParent === -1) {
        newCheckedParent.push(parentId);

        const currentIndexSystem = newCheckedParent?.findIndex(
          (s) => String(s) === String(system)
        );
        if (currentIndexSystem === -1) {
          newCheckedParent.push(system);
        }

        verifyChild?.forEach((item) => {
          if (newCheckedChild?.indexOf(item) === -1) {
            newCheckedChild.push(item);
          }
        });

        allChildrenIds.forEach((childId) => {
          if (newCheckedChild?.indexOf(childId) === -1) {
            newCheckedChild.push(childId);
          }
        });
      } else {
        newCheckedChild = newCheckedChild.filter(function (childItem) {
          return (
            verifyChild.indexOf(childItem) === -1 &&
            !allChildrenIds.includes(childItem)
          );
        });

        newCheckedParent.splice(currentIndexParent, 1);

        const isInArray = verifyParent.some((el) =>
          newCheckedParent.some((p) => String(p) === String(el))
        );
        if (!isInArray) {
          const currentIndexSystem = newCheckedParent?.findIndex(
            (s) => String(s) === String(system)
          );
          if (currentIndexSystem !== -1) {
            newCheckedParent.splice(currentIndexSystem, 1);
          }
        }
      }
      setParentLinked(newCheckedParent);
      setChildLinked(newCheckedChild);
    },
    [
      childLinked,
      setChildLinked,
      parentLinked,
      setParentLinked,
      getAllChildrenIds,
    ]
  );

  const toggleChildrenRecursive = useCallback(
    (children, newCheckedChild, isAdding) => {
      if (!children || children.length === 0) return;

      children.forEach((child) => {
        const currentIndex = newCheckedChild?.indexOf(child?.IdMenu);
        if (isAdding) {
          if (currentIndex === -1) {
            newCheckedChild.push(child?.IdMenu);
          }
        } else {
          if (currentIndex !== -1) {
            newCheckedChild.splice(currentIndex, 1);
          }
        }

        if (child?.ListMenusFilhos && child?.ListMenusFilhos.length > 0) {
          toggleChildrenRecursive(
            child.ListMenusFilhos,
            newCheckedChild,
            isAdding
          );
        }
      });
    },
    []
  );

  const handleToggleAllList = useCallback(
    (system, options) => {
      const newCheckedParent = [...parentLinked];
      const newCheckedChild = [...childLinked];

      const systemIndex = newCheckedParent?.findIndex(
        (s) => String(s) === String(system)
      );

      if (systemIndex !== -1) {
        options?.ListMenus?.forEach((parent) => {
          const currentIndexParent = newCheckedParent?.findIndex(
            (p) => String(p) === String(parent?.IdMenu)
          );
          if (currentIndexParent !== -1) {
            newCheckedParent.splice(currentIndexParent, 1);
          }

          if (parent?.ListMenusFilhos && parent?.ListMenusFilhos.length > 0) {
            toggleChildrenRecursive(
              parent.ListMenusFilhos,
              newCheckedChild,
              false
            );
          }
        });

        // Recalcula o índice do sistema após remover os pais
        const finalSystemIndex = newCheckedParent?.findIndex(
          (s) => String(s) === String(system)
        );
        if (finalSystemIndex !== -1) {
          newCheckedParent.splice(finalSystemIndex, 1);
        }

        setParentLinked(newCheckedParent);
        setChildLinked(newCheckedChild);
      } else {
        options?.ListMenus?.forEach((parent) => {
          const currentIndexParent = newCheckedParent?.findIndex(
            (p) => String(p) === String(parent?.IdMenu)
          );
          if (currentIndexParent === -1) {
            newCheckedParent.push(parent?.IdMenu);
          }

          if (parent?.ListMenusFilhos && parent?.ListMenusFilhos.length > 0) {
            toggleChildrenRecursive(
              parent.ListMenusFilhos,
              newCheckedChild,
              true
            );
          }
        });

        const currentIndexSystem = newCheckedParent?.findIndex(
          (s) => String(s) === String(system)
        );
        if (currentIndexSystem === -1) {
          newCheckedParent.push(system);
        }

        setParentLinked(newCheckedParent);
        setChildLinked(newCheckedChild);
      }
    },
    [
      childLinked,
      setChildLinked,
      parentLinked,
      setParentLinked,
      toggleChildrenRecursive,
    ]
  );

  const toggleExpanded = useCallback((itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  }, []);

  const isExpanded = useCallback(
    (itemId) => {
      return expandedItems[itemId] || false;
    },
    [expandedItems]
  );

  const shouldShowInFilter = useCallback(
    (item, listSubSystemFilter) => {
      if (
        !showListSubOptionsFilter ||
        !listSubSystemFilter ||
        listSubSystemFilter.length === 0
      ) {
        return false;
      }
      return (
        listSubSystemFilter.includes(item?.Descricao) ||
        listSubSystemFilter.includes(item?.IdMenu)
      );
    },
    [showListSubOptionsFilter]
  );

  const hasAnyChildSelected = useCallback((children, childLinkedList) => {
    if (!children || children.length === 0) return false;

    for (const child of children) {
      const childId = child?.IdMenu || child?.Descricao;
      if (childLinkedList?.indexOf(childId) !== -1) {
        return true;
      }
      if (
        child?.ListMenusFilhos &&
        child?.ListMenusFilhos.length > 0 &&
        hasAnyChildSelected(child.ListMenusFilhos, childLinkedList)
      ) {
        return true;
      }
    }
    return false;
  }, []);

  const hasAnyItemSelectedInSystem = useCallback(
    (systemMenus, systemId, parentLinkedList, childLinkedList) => {
      if (!systemMenus || systemMenus.length === 0) return false;

      // Verifica se o sistema está em parentLinked
      if (
        parentLinkedList?.findIndex((p) => String(p) === String(systemId)) !==
        -1
      ) {
        return true;
      }

      // Verifica se há algum pai (nível 2) selecionado
      for (const menu of systemMenus) {
        if (
          parentLinkedList?.findIndex(
            (p) => String(p) === String(menu?.IdMenu)
          ) !== -1
        ) {
          return true;
        }

        // Verifica se há algum filho (nível 3) selecionado
        if (
          menu?.ListMenusFilhos &&
          menu?.ListMenusFilhos.length > 0 &&
          hasAnyChildSelected(menu.ListMenusFilhos, childLinkedList)
        ) {
          return true;
        }
      }

      return false;
    },
    [hasAnyChildSelected]
  );

  const renderMenuItem = useCallback(
    (item, level, parentId, system, parentList, allSystemParents) => {
      const hasChildren =
        item?.ListMenusFilhos && item?.ListMenusFilhos.length > 0;
      const itemId = item?.IdMenu || item?.Descricao;
      const expanded = isExpanded(itemId);
      const showInFilter = shouldShowInFilter(item, listSubSystemFilter);
      const shouldShow = expanded || showInFilter;
      const marginLeft = `${1.5 + level}rem`;
      const marginTop = "-2rem";
      const marginBottom = "-2rem";
      const isChecked =
        childLinked?.indexOf(itemId) !== -1 ||
        (hasChildren &&
          hasAnyChildSelected(item?.ListMenusFilhos, childLinked));

      return (
        <div key={itemId}>
          <ListItem
            style={{
              marginLeft,
              marginTop,
              marginBottom,
            }}
            role="listitem"
            draggable
            className={classes.listItem}
          >
            {hasChildren ? (
              <IconButton size="small" onClick={() => toggleExpanded(itemId)}>
                {shouldShow ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            ) : (
              <div role="presentation" style={{ marginLeft: "1.85rem" }} />
            )}
            <ListItemIcon style={{ marginRight: "-0.5rem" }}>
              <Checkbox
                checked={isChecked}
                tabIndex={-1}
                inputProps={{
                  "aria-labelledby": itemId,
                }}
                color="primary"
                onClick={() =>
                  handleToggleChild(
                    itemId,
                    parentId,
                    parentList || [],
                    system,
                    allSystemParents || []
                  )
                }
              />
            </ListItemIcon>
            <Tooltip title={item?.Descricao}>
              <ListItemText id={itemId} primary={item?.Descricao} />
            </Tooltip>
          </ListItem>
          {hasChildren &&
            shouldShow &&
            item?.ListMenusFilhos?.map((child) => {
              return renderMenuItem(
                child,
                level + 1,
                itemId,
                system,
                item?.ListMenusFilhos,
                allSystemParents
              );
            })}
        </div>
      );
    },
    [
      classes.listItem,
      childLinked,
      isExpanded,
      shouldShowInFilter,
      listSubSystemFilter,
      toggleExpanded,
      handleToggleChild,
      hasAnyChildSelected,
    ]
  );

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={
            isMobile
              ? {
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }
              : {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "0.1rem solid #D0D0D0",
                }
          }
        >
          {!loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                className={classes.cardHeader}
                style={{ color: "#994E53", marginRight: "1rem" }}
              >
                {label}
              </Typography>
              <Typography
                className={classes.cardHeader}
                style={{ color: "rgba(0, 0, 0, 0.54)" }}
              >
                {`${countRight}/${countLeft} selecionados`}
              </Typography>
            </div>
          )}
          {!loading && (
            <ItemsFilter
              label={label}
              filteringItems={filteringItems}
              loading={loading}
              verifyItems={verifyItems}
            />
          )}
        </Grid>
        {!loading && <Divider />}
        {items?.length !== 0 && (
          <div
            className={classes.list}
            style={{ overflowX: "hidden", width: "100%" }}
          >
            {!loading && items ? (
              items?.map((menuOptions) => {
                const systemId = menuOptions?.Sistema;
                const systemExpanded =
                  isExpanded(systemId) ||
                  (showListSubOptionsFilter &&
                    listSubSystemFilter?.includes(systemId));

                return (
                  <div key={systemId}>
                    <ListItem
                      style={{
                        marginTop: "-0.75rem",
                        marginBottom: "-2.25rem",
                      }}
                      role="listitem"
                      draggable
                      className={classes.listItem}
                    >
                      <IconButton
                        size="small"
                        onClick={() => toggleExpanded(systemId)}
                      >
                        {systemExpanded ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                      <ListItemIcon style={{ marginRight: "-0.5rem" }}>
                        <Checkbox
                          checked={
                            parentLinked?.findIndex(
                              (p) => String(p) === String(systemId)
                            ) !== -1 ||
                            hasAnyItemSelectedInSystem(
                              menuOptions?.ListMenus,
                              systemId,
                              parentLinked,
                              childLinked
                            )
                          }
                          tabIndex={-1}
                          color="primary"
                          onClick={() =>
                            handleToggleAllList(systemId, menuOptions)
                          }
                        />
                      </ListItemIcon>
                      <Tooltip title={systemId}>
                        <ListItemText id={systemId} primary={systemId} />
                      </Tooltip>
                    </ListItem>
                    {systemExpanded &&
                      menuOptions?.ListMenus?.map((options) => {
                        const parentExpanded =
                          isExpanded(options?.IdMenu) ||
                          shouldShowInFilter(options, listSubSystemFilter);

                        return (
                          <div key={options?.IdMenu}>
                            <ListItem
                              style={{
                                marginLeft: "1.5rem",
                                marginTop: "-2.25rem",
                                marginBottom: "-2.25rem",
                              }}
                              role="listitem"
                              draggable
                              className={classes.listItem}
                            >
                              {options?.ListMenusFilhos?.length !== 0 ? (
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    toggleExpanded(options?.IdMenu)
                                  }
                                >
                                  {parentExpanded ? (
                                    <ExpandLess />
                                  ) : (
                                    <ExpandMore />
                                  )}
                                </IconButton>
                              ) : (
                                <div
                                  role="presentation"
                                  style={{ marginLeft: "1.85rem" }}
                                />
                              )}
                              <ListItemIcon style={{ marginRight: "-0.5rem" }}>
                                <Checkbox
                                  checked={
                                    parentLinked?.findIndex(
                                      (p) =>
                                        String(p) === String(options?.IdMenu)
                                    ) !== -1 ||
                                    (options?.ListMenusFilhos &&
                                      options?.ListMenusFilhos.length > 0 &&
                                      hasAnyChildSelected(
                                        options?.ListMenusFilhos,
                                        childLinked
                                      ))
                                  }
                                  tabIndex={-1}
                                  inputProps={{
                                    "aria-labelledby": options?.IdMenu,
                                  }}
                                  color="primary"
                                  onClick={() =>
                                    handleToggleParent(
                                      options?.IdMenu,
                                      options?.ListMenusFilhos,
                                      systemId,
                                      menuOptions?.ListMenus
                                    )
                                  }
                                />
                              </ListItemIcon>
                              <Tooltip title={options?.Descricao}>
                                <ListItemText
                                  id={options?.IdMenu}
                                  primary={options?.Descricao}
                                />
                              </Tooltip>
                            </ListItem>
                            {parentExpanded &&
                              options?.ListMenusFilhos?.map((filho) => {
                                return renderMenuItem(
                                  filho,
                                  2,
                                  options?.IdMenu,
                                  systemId,
                                  options?.ListMenusFilhos,
                                  menuOptions?.ListMenus
                                );
                              })}
                          </div>
                        );
                      })}
                  </div>
                );
              })
            ) : (
              <>
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
              </>
            )}
          </div>
        )}
      </Grid>
    </>
  );
};

export default function TransferList({
  loading,
  initial,
  label,
  setVinculados,
}) {
  const isMobile = IsMobile();

  const classes = useStyles();
  const [items, setItems] = useState(initial || null);
  const [childLinked, setChildLinked] = useState([]);
  const [parentLinked, setParentLinked] = useState([]);

  useEffect(() => {
    setItems(initial);
  }, [initial]);

  useEffect(() => {
    const listVinculados = parentLinked.concat(childLinked);
    initial?.map((options) => {
      const currentIndexSystem = listVinculados?.indexOf(options?.Sistema);
      if (currentIndexSystem !== -1) {
        listVinculados.splice(currentIndexSystem, 1);
      }
    });
    setVinculados(listVinculados);
  }, [parentLinked, childLinked]);

  const collectLinkedItems = useCallback(
    (children, parentLinkedList, childLinkedList, system) => {
      if (!children || children.length === 0) return;

      children.forEach((child) => {
        if (child?.Vinculado === true) {
          childLinkedList.push(child?.IdMenu);
        }

        if (child?.ListMenusFilhos && child?.ListMenusFilhos.length > 0) {
          collectLinkedItems(
            child.ListMenusFilhos,
            parentLinkedList,
            childLinkedList,
            system
          );
        }
      });
    },
    []
  );

  useEffect(() => {
    const parentLinkedList = [];
    const childLinkedList = [];
    initial?.forEach((options) => {
      options?.ListMenus?.forEach((parent) => {
        if (parent?.Vinculado === true) {
          if (parentLinkedList.indexOf(options?.Sistema) === -1) {
            parentLinkedList.push(options?.Sistema);
          }
          parentLinkedList.push(parent?.IdMenu);
        }

        if (parent?.ListMenusFilhos && parent?.ListMenusFilhos.length > 0) {
          collectLinkedItems(
            parent.ListMenusFilhos,
            parentLinkedList,
            childLinkedList,
            options?.Sistema
          );
        }
      });
    });

    setParentLinked(parentLinkedList);
    setChildLinked(childLinkedList);
  }, [initial, collectLinkedItems]);

  return (
    <Grid container alignItems="flex-start" className={classes.root}>
      <Grid
        item
        xs={12}
        style={isMobile ? { padding: "0 0.5rem" } : { padding: "0 2rem" }}
      >
        <ItemsList
          label={label}
          initialItems={items}
          loading={loading}
          childLinked={childLinked}
          setChildLinked={setChildLinked}
          parentLinked={parentLinked}
          setParentLinked={setParentLinked}
        />
      </Grid>
    </Grid>
  );
}
